import styled from '@emotion/styled';

const FormWrapper = styled('form')({
  display: 'flex',
  alignItems: 'center',
});

export default FormWrapper;
